<a
  nz-button
  nzType="link"
  nzSize="small"
  nz-dropdown
  [nzDropdownMenu]="shareCheckinInfo"
  (mouseenter)="fetchCopyLink()"
>
  <!-- 入住指南 -->
  {{ "order.checkin_guide" | translate }}
</a>
<nz-dropdown-menu #shareCheckinInfo="nzDropdownMenu">
  <ul nz-menu nzSelectable class="menu-list">
    <li nz-menu-item>
      <!-- 复制链接 -->
      <div class="share-copy" hostClipboard [clipboardData]="checkGuideLink">
        {{ "order.copy_link" | translate }}
      </div>
    </li>
    <li nz-menu-item (click)="onClickShowShareQRCode()">
      <!-- 微信扫码 -->
      {{ "order.scan_wechat_code" | translate }}
    </li>
    <li nz-menu-item (click)="onClickSendEmail()">
      <!-- 发送邮件 -->
      {{ "order.send_email" | translate }}
    </li>
  </ul>
</nz-dropdown-menu>

<!-- 入住指南分享二维码 -->
<ng-template #shareQRCodeTpl>
  <div class="share-qrcode-tpl">
    <img src="/api/reservation/guide_qrcode?reservation_code={{ code }}" />
  </div>
</ng-template>

<!-- 入住指南分享发邮件 -->
<ng-template #sendEmailTpl>
  <div class="send-email-tpl">
    <div class="content">
      <textarea
        rows="7"
        type="text"
        style="margin-top: 0"
        nz-input
        [(ngModel)]="emails"
        placeholder="{{ 'placeholde.email_address_one_per_line' | translate }}"
      ></textarea>
    </div>
    <div class="footer">
      <button nz-button (click)="onCancelSendEmail()">
        {{ "word.cancel" | translate }}
      </button>
      <button nz-button nzType="primary" (click)="onConfirmSendEmail()">
        {{ "word.send" | translate }}
      </button>
    </div>
  </div>
</ng-template>
